// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStateHook,
	type ActionThunk,
	type HookStateFunction,
	type Selector,
	type Store,
} from '@atlassian/react-sweet-state';

export function getCreateStoreHook<
	TState,
	TActions extends Record<string, ActionThunk<TState, TActions>>,
>(store: Store<TState, TActions>) {
	return function createStoreHook<TValue, THookProps = void>(
		selector: Selector<TState, THookProps, TValue>,
	): HookStateFunction<TValue, THookProps> {
		return createStateHook(store, { selector });
	};
}
